var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoboomiText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 16,
    viewBox: "0 0 82 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 11.7105L21.0064 10.5066C21.5237 11.212 22.1444 11.5882 22.8875 11.5882C23.8656 11.5882 24.3641 11.0051 24.3641 9.83882V4.51537H21.834V3.03873H26.1229V9.74477C26.1229 11.9833 25.0131 13.0743 22.9251 13.0743C21.7306 13.0743 20.649 12.5852 20 11.7105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5807 9.33093C27.5807 7.16769 29.2079 5.63461 31.4275 5.63461C33.6472 5.63461 35.2837 7.16769 35.2837 9.33093C35.2837 11.4942 33.6754 13.0461 31.4275 13.0461C29.1796 13.0461 27.5807 11.5036 27.5807 9.33093ZM33.5814 9.33093C33.5814 7.94834 32.6596 7.06423 31.4275 7.06423C30.1954 7.06423 29.2831 7.94834 29.2831 9.33093C29.2831 10.7135 30.2048 11.5976 31.4275 11.5976C32.6502 11.5976 33.5814 10.7135 33.5814 9.33093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2095 9.33093C44.2095 11.5788 42.6482 13.0461 40.5414 13.0461C39.5538 13.0461 38.7167 12.7075 38.143 12.0209V12.952H36.5347V2.89764H38.2276V6.59396C38.8108 5.94499 39.6196 5.63461 40.5414 5.63461C42.6576 5.63461 44.2095 7.08304 44.2095 9.33093ZM42.4883 9.33093C42.4883 7.94834 41.5666 7.06423 40.3438 7.06423C39.1211 7.06423 38.19 7.94834 38.19 9.33093C38.19 10.7135 39.1211 11.5976 40.3438 11.5976C41.5666 11.5976 42.4883 10.7135 42.4883 9.33093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4322 9.33093C45.4322 7.16769 47.0593 5.63461 49.279 5.63461C51.4986 5.63461 53.1352 7.16769 53.1352 9.33093C53.1352 11.4942 51.5269 13.0461 49.279 13.0461C47.0311 13.0461 45.4322 11.5036 45.4322 9.33093ZM51.4328 9.33093C51.4328 7.94834 50.5111 7.06423 49.279 7.06423C48.0469 7.06423 47.1345 7.94834 47.1345 9.33093C47.1345 10.7135 48.0563 11.5976 49.279 11.5976C50.5017 11.5976 51.4328 10.7135 51.4328 9.33093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3673 9.33093C54.3673 7.16769 55.9944 5.63461 58.2141 5.63461C60.4338 5.63461 62.0703 7.16769 62.0703 9.33093C62.0703 11.4942 60.462 13.0461 58.2141 13.0461C55.9662 13.0461 54.3673 11.5036 54.3673 9.33093ZM60.3679 9.33093C60.3679 7.94834 59.4462 7.06423 58.2141 7.06423C56.982 7.06423 56.0697 7.94834 56.0697 9.33093C56.0697 10.7135 56.9914 11.5976 58.2141 11.5976C59.4368 11.5976 60.3679 10.7135 60.3679 9.33093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.52 8.80423V12.952H73.827V9.02055C73.827 7.73201 73.2345 7.11126 72.1999 7.11126C71.0901 7.11126 70.3188 7.84488 70.3188 9.2745V12.9426H68.6259V9.01114C68.6259 7.72261 68.0333 7.10185 66.9987 7.10185C65.8701 7.10185 65.1176 7.83547 65.1176 9.26509V12.9332H63.4247V5.70045H65.033V6.62218C65.5785 5.9732 66.4156 5.6158 67.4032 5.6158C68.4566 5.6158 69.3407 6.01083 69.8392 6.81969C70.4223 6.07666 71.4005 5.6158 72.5479 5.6158C74.2973 5.6158 75.5106 6.60337 75.5106 8.78542L75.52 8.80423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1001 5.70987H78.7931V12.9426H77.1001V5.70987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8902 2.14522C77.4951 2.14522 77.1377 2.35214 76.9496 2.70014L76.9214 2.74716C76.7333 3.07635 76.7333 3.48078 76.9214 3.80997L76.9496 3.857C77.1377 4.19559 77.5045 4.41192 77.8902 4.41192C78.2852 4.41192 78.6426 4.205 78.8307 3.857L78.8589 3.80997C79.047 3.48078 79.047 3.07635 78.8589 2.74716L78.8307 2.70014C78.6426 2.36154 78.2758 2.14522 77.8902 2.14522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.619995 4.23V11.77L7.16 15.54L13.69 11.77V4.23L7.16 0.449997L0.619995 4.23Z",
    fill: "url(#paint0_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16 16C6.87 16 6.57 15.92 6.32 15.77L0.84 12.62C0.32 12.32 0 11.76 0 11.16V4.84C0 4.24 0.32 3.68 0.84 3.38L6.31 0.219995C6.82 -0.0800049 7.48 -0.0800049 8 0.219995L13.47 3.38C13.99 3.68 14.31 4.24 14.31 4.84V11.16C14.31 11.76 13.99 12.32 13.47 12.62L8 15.78C7.74 15.93 7.45 16.01 7.16 16.01V16ZM7.16 0.789995C7 0.789995 6.85 0.829995 6.72 0.909995L1.24 4.07C0.97 4.23 0.8 4.52 0.8 4.84V11.16C0.8 11.48 0.97 11.77 1.24 11.93L6.71 15.09C6.98 15.25 7.33 15.24 7.6 15.09L13.07 11.93C13.34 11.77 13.51 11.48 13.51 11.16V4.84C13.51 4.52 13.34 4.23 13.07 4.07L7.6 0.909995C7.47 0.829995 7.31 0.789995 7.16 0.789995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05001 11.76C4.02001 11.76 3.06001 11.2 2.55001 10.3L2.51001 10.24L3.55001 9.37L3.60001 9.48C3.84001 10.07 4.41001 10.46 5.05001 10.46C5.91001 10.46 6.61001 9.76 6.61001 8.9V4.13H7.91001V8.9C7.91001 10.48 6.62001 11.77 5.04001 11.77L5.05001 11.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48002 11.76C8.84002 11.76 8.25002 11.54 7.83002 11.13L7.77002 11.07L7.82002 11.01C8.03002 10.76 8.20002 10.49 8.33002 10.19L8.40002 10.02L8.49002 10.18C8.69002 10.54 9.05002 10.75 9.48002 10.75C10.17 10.75 10.63 10.26 10.63 9.54001C10.63 8.82001 10.17 8.33001 9.48002 8.33001C9.20002 8.33001 8.94002 8.42001 8.75002 8.58001L8.60002 8.70001V7.47001L8.66002 7.45001C8.92002 7.36001 9.20002 7.32001 9.48002 7.32001C10.82 7.32001 11.79 8.25001 11.79 9.54001C11.79 10.83 10.82 11.77 9.48002 11.77V11.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17001 5.41H4.29001V4.11H6.17001V5.41Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 1.92,
    y1: 16.19,
    x2: 13.59,
    y2: -2.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#551EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#581FB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#6325CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#6727D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#5B33D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3E54EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#2373FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2482FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#28A5FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81.1,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoboomiText);
export default __webpack_public_path__ + "static/media/JoboomiText.4d2e8803f10c7e8f0032c0c65c6adb78.svg";
export { ForwardRef as ReactComponent };